import BlockTitle from '@/src/components/Modules-revamp/BlockTitle';
import FieldLinkLibrary from '@/src/components/Modules-revamp/FieldLinkLibrary';
import ModuleHeight from '@/src/components/Modules-revamp/ModuleHeight';
import ModuleWidth from '@/src/components/Modules-revamp/ModuleWidthSelect';
import { Field } from '@/src/components/RcForm';
import { ResponsiveContainer, ResponsiveField } from '@/src/strategies/util';
import { get } from 'lodash';
import React from 'react';
import Wrapper from 'src/components/Modules-revamp/BlockWrapper';
import iframeRenderTemplate from 'src/strategies/render/iframe';
import moduleStyleRender from '../../ModuleStyle';

import { iframeLink } from '@/src/tools/contentModulesFieldName';
import { validateIframeLink } from '../../ModuleList/validator';

type ResponsiveFieldProps = {
  field: ResponsiveField | ResponsiveField[];
  disabled?: boolean;
  options?: Array<{ label: string; value: any }>;
  hasModal?: boolean;
  modalFunc?: any;
  title?: string;
};
const iframeComponent = (
  data: ResponsiveFieldProps,
  breakpoint: any,
  extra: any,
) => {
  switch (data.field) {
    case ResponsiveField.IframeLink: {
      const { checkIframeLink } = validateIframeLink();
      return (
        <FieldLinkLibrary
          title={data?.title}
          name={iframeLink}
          disabled={data.disabled}
          validators={{
            link: checkIframeLink,
          }}
          breakpoint={breakpoint}
        />
      );
    }
    case ResponsiveField.ModuleWidth: {
      return (
        <ModuleWidth disabled={data?.disabled} options={data?.options || []} />
      );
    }
    case ResponsiveField.ModuleHeight: {
      return (
        <ModuleHeight
          title={data?.title}
          disabled={data?.disabled}
          options={data?.options || []}
        />
      );
    }
    default:
      return;
  }
};
const iframeRender = (form: any, breakpoint: any, extra: any) => {
  const values = form.getFieldsValue(true);
  const { handleOnSectionReset, handleOnSectionCopy } = extra;
  const list = iframeRenderTemplate(values, breakpoint);
  const renderComponents = (
    {
      type,
      field,
    }: {
      title?: string;
      titleHide?: boolean;
      type?: ResponsiveContainer;
      field: Array<any>;
    },
    breakpoint: any,
  ) => {
    if (type === ResponsiveContainer.ModuleStyle) {
      return field.map((f) => moduleStyleRender(f));
    } else {
      return field.map((f) => iframeComponent(f, breakpoint, extra));
    }
  };
  return (
    <>
      {list.map((item, index) => {
        const component = renderComponents(item, breakpoint);
        return (
          <>
            <Wrapper
              key={`${item.title}_${index}`}
              id={`${item?.id}`}
              breakpoint={breakpoint}>
              <BlockTitle
                id={item?.id}
                title={item?.title}
                breakpoint={breakpoint}
                onReset={() =>
                  handleOnSectionReset(item?.fields, breakpoint, { item })
                }
                onCopy={() =>
                  handleOnSectionCopy(item?.fields, breakpoint, { item })
                }
                dependencies={get(item, 'dependencies')}
                validator={get(item, 'validator')}
              />
              {component}
            </Wrapper>
          </>
        );
      })}
    </>
  );
};

export default ({ form, breakpoint, ...extra }: any) => {
  return (
    <Field shouldUpdate>
      {() =>
        iframeRender(form, breakpoint, {
          form,
          ...extra,
        })
      }
    </Field>
  );
};
